<!--
 * @Author: awu
 * @Date: 2020-11-16 23:23:26
 * @LastEditors: awu
 * @LastEditTime: 2020-12-05 20:50:21
 * @Description: 咨询台-联系我们
-->
<template>
    <div class="relation">
        <div class="backHome" @click="backHome">
            <img src="../../assets/user/close.png" alt="">
        </div>
        <div class="top">{{ consult.title }}</div>
        <div class="bot">
            <div class="bot-item">
                <div class="bot-item-name box">
                    <span>{{ consult.name }}*:</span>
                    <input type="text" v-model="name">
                </div>
                <div class="bot-item-region box">
                    <span>{{ consult.gj }}*:</span>
                     <el-select filterable class="select" v-model="country" :placeholder="$t('register').countryPlaceholder">
                        <el-option v-for="item in countrys" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                    </el-select>
                </div>
            </div>
            <div class="bot-item">
                <div class="bot-item-mail box">
                    <span>{{ consult.yx }}*:</span>
                    <input type="text" v-model="mail">
                </div>
                <div class="bot-item-tell box">
                    <span>{{ consult.tell }}*:</span>
                    <input type="text" v-model="phone">
                </div>
            </div>
            <div class="textarea">
                <span>我的问题:</span>
                <textarea v-model="question"></textarea>
            </div>
            <div class="bot-btn" @click="sub">{{ consult.tj }}</div>
            <div class="bot-msg1">
              {{contactUsTips[$store.state.currentExhibition].message}}<br /><br />
              {{contactUsTips[$store.state.currentExhibition].workTime}} <br />
              {{contactUsTips[$store.state.currentExhibition].phone}}
            </div>
        </div>
    </div>
</template>

<script>
import api from "@/api";
import Vue from "vue";
import { mapState } from "vuex";
export default {
    data() {
        return {
            countrys: [],
            name: "",
            country: "",
            mail: "",
            phone: "",
            question: ""
        };
    },
    mounted() {
        this.getCountry();
        this.mail = this.userInfo.email
        this.country = this.userInfo.country_name
        this.name = this.userInfo.nick_name
        this.phone = this.userInfo.phone
    },
    methods: {
        backHome() {
            this.$root.$emit('close')
            this.$router.push("/area/consult");
        },
        getCountry() {
            api.getCountry().then((res) => {
                if (res.res === 1) {
                    const defaultLanguage = localStorage.getItem("language") || "zh";
                    this.countrys = res.country.map((item) => {
                        return {
                            value: item.code,
                            label: defaultLanguage === "zh" ? item.zh : item.en
                        };
                    });
                }
            });
        },
        sub() {
            if (!this.name) {
                this.error(this.consult.noName);
                return;
            }
            if (!this.country) {
                this.$message.error(this.consult.noCountry);
                return;
            }
            if (!this.mail) {
                this.$message.error(this.consult.noMail);
                return;
            }
            if (!this.phone) {
                this.$message.error(this.consult.noPhone);
                return;
            }
            let params = {
                name: this.name,
                country: this.country,
                email: this.mail,
                phone: this.phone,
                question: this.question,
                exhibition_id: 14
            };
            api.contactUs(params).then((res) => {
                if (res.res === 1) {
                    this.$message.success(this.consult.success);
                    this.$root.$emit('close')
                    this.$router.push("/area/consult");
                }
            });
        }
    },
    computed: {
        consult() {
            return this.$t("consult");
        },
        contactUsTips() {
            return this.$t("contactUsTips");
        },
        ...mapState(["userInfo"]),
    }
};
</script>

<style lang="scss" scoped>
.relation {
    width: 469px;
    height: 495px;
    background: #ffffff;
    box-shadow: 0px 5px 7px 3px rgba(0, 0, 0, 0.3);
    border-radius: 20px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .top {
        width: 100%;
        height: 53px;
        line-height: 53px;
        border-radius: 20px 20px 0 0;
        text-align: center;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #09468C;
    }
    .bot {
        width: 100%;
        height: 442px;
        box-sizing: border-box;
        padding-top: 10px;
        padding: 10px 29px 0;
        &-item{
            width: 100%;
            height: 33px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 16px;
            .box{
                background:#E0E6EE;
                border-radius: 20px;
                height: 100%;
                box-sizing: border-box;
                padding: 0 10px 0 14px;
                font-size: 11px;
                display: flex;
                align-items: center;
                >input{
                    text-align: center;
                    background-color: transparent;
                    flex: 1;
                    color: #09468C;
                }
                >span{

                    color: rgba(9, 70, 140, 0.29);
                    flex-shrink: 0;
                }

            }
            &-name{
                width: 199px;
            }
            &-region{
                width: 203px;
                .select {
                    height: 27px;
                    border-radius: 13px;
                    width: 100%;
                    /deep/ .el-input {
                        font-size: 11px;
                        color: red;
                        .el-input__suffix {
                            right: 10px;
                            bottom: 10px;
                            width: 43px;
                            height: 26px;
                            background: transparent;
                            .el-input__suffix-inner {
                                color: red;
                                top: -6px;
                                position: absolute;
                            }
                            input {
                                color: red;
                            }
                        }
                        .el-input__inner {
                            height: 27px;
                            border: none;
                            background: transparent;
                            color: #09468C;
                        }
                        input:-ms-input-placeholder,textarea:-ms-input-placeholder {
                            color: #E0E6EE;
                        }
                        input::-webkit-input-placeholder,textarea::-webkit-input-placeholder {
                            color: #E0E6EE;
                        }

                        .el-select__caret {
                            font-size: 16px;
                            color: rgba(9, 70, 140, 0.29);
                        }
                    }
                }
            }
            &-mail{
                width: 191px;
            }
            &-tell{
                 width: 212px;
            }
        }
        .textarea{
            position: relative;
            span{
                position: absolute;
                top: 9px;
                left: 13px;
                font-size: 11px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: rgba(9, 70, 140, 0.29);
            }
        }
        textarea{
            width: 100%;
            height: 157px;
            background:#E0E6EE;
            box-shadow: 0px 1px 3px 0px rgba(0,0,0,0.2), 0px 1px 3px 0px rgba(255,255,255,0.4), 0px 0px 4px 3px rgba(255,255,255,0.1);
            border-radius: 13px;
            border: 0;
            outline: 0;
            box-sizing: border-box;
            padding: 8px 13px;
            font-size: 11px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #09468C;
            line-height: 15px;
            text-indent: 58px;
            resize: none;
        }
        &-btn{
            width: 134px;
            height: 39px;
            background: #09468C;
            border-radius: 12px;
            margin: 12px auto 19px;
            font-size: 13px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
            line-height: 39px;
            letter-spacing: 7px;
            text-align: center;
        }
        &-msg1{
            font-size: 8px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #09468C;
            text-align: center;
            width: 320px;
            margin: 0 auto;
            line-height: 13px;
        }

        .item {
            width: 100%;
            height: 27px;
            display: flex;
            align-items: center;
            font-size: 12px;
            font-weight: 400;
            color: #5f7185;
            margin-bottom: 13px;
            .title {
                width: 83px;
                text-align: right;
                margin-right: 7px;
            }
            .pt {
                padding-top: 10px;
            }
            .bc {
                height: 100%;
                width: 557px;
                background: #5f7185;
                box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 3px 0px rgba(255, 255, 255, 0.4), 0px 0px 4px 3px rgba(255, 255, 255, 0.1);
                border-radius: 13px;
                font-size: 11px;
                font-weight: 400;
                color: #dfe8f9;
                .select {
                    height: 27px;
                    border-radius: 13px;
                    width: 100%;
                    /deep/ .el-input {
                        font-size: 11px;
                        color: #dfe8f9;
                        .el-input__suffix {
                            right: 10px;
                            bottom: 10px;
                            width: 43px;
                            height: 26px;
                            background: #5f7185;
                            .el-input__suffix-inner {
                                color: red;
                                top: -6px;
                                position: absolute;
                            }
                            input {
                                color: #dfe8f9;
                            }
                        }
                        .el-input__inner {
                            height: 27px;
                            border: none;
                            background: transparent;
                            color: #dfe8f9;
                        }

                        .el-select__caret {
                            font-size: 16px;
                            color: #fff;
                        }
                    }
                }
                input {
                    width: 100%;
                    height: 100%;
                    border: 0;
                    background-color: transparent;
                    box-sizing: border-box;
                    padding: 2px 10px;
                    color: #dfe8f9;
                }
            }
            > textarea {
                width: 557px;
                height: 90px;
                background: #5f7185;
                box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 3px 0px rgba(255, 255, 255, 0.4), 0px 0px 4px 3px rgba(255, 255, 255, 0.1);
                border-radius: 13px;
                border: 0;
                outline: 0;
                box-sizing: border-box;
                padding: 10px;
                color: #dfe8f9;
            }
        }
    }
    .btn {
        width: 557px;
        height: 40px;
        background: #226eff;
        box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
        border-radius: 20px;
        margin: 80px 0 0 90px;
        text-align: center;
        line-height: 40px;
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
    }
    .msg1 {
        width: 230px;
        height: 67px;
        font-size: 9px;
        font-weight: 400;
        color: #a4c3ff;
        line-height: 13px;
        position: absolute;
        left: 90px;
        bottom: 23px;
        text-align: justify;
    }
    .msg2 {
        width: 206px;
        height: 40px;
        font-size: 9px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #a4c3ff;
        line-height: 16px;
        position: absolute;
        left: 369px;
        bottom: 54px;
    }
    .backHome {
        width: 33px;
        height: 33px;
        position: absolute;
        top: 12px;
        right: 21px;
        cursor: pointer;
        border-radius: 50%;
        >img{
            width: 100%;
            height: 100%;
        }
    }
    .backHome:hover{
        background-color: #E8EEF4;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/consult/relation.vue